import axios from "axios";
import { API_BASE_URL } from "../../config";
import { APP_TOKEN_KEY } from "../redux/appAuthSlice";

const conversionApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

conversionApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(APP_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function getConversionInfo(userId) {
  const { data } = await conversionApi.get(`/api/conversions/info/${userId}`);
  return data;
}

export async function convertCashToCoin({ userId, cashAmount }) {
  const { data } = await conversionApi.post("/api/conversions/cash-to-coin", {
    userId,
    cashAmount,
  });
  return data;
}

export async function convertCoinToCash({ userId, coinAmount }) {
  const { data } = await conversionApi.post("/api/conversions/coin-to-cash", {
    userId,
    coinAmount,
  });
  return data;
}
